class SlotRenderData {
	constructor(event) {
		this.advertiserId = event.advertiserId;
		this.campaignId = event.campaignId;
		this.creativeId = event.creativeId;
		this.isEmpty = event.isEmpty;
		this.lineItemId = event.lineItemId;
		this.size = event.size;
		this.sourceAgnosticCreativeId = event.sourceAgnosticCreativeId;
		this.sourceAgnosticLineItemId = event.sourceAgnosticLineItemId;
	}
}

module.exports = SlotRenderData;
